import React, { useEffect, useCallback, useState} from 'react';
import ContextualHelp from "components/sidebar/ContextualHelpComponent.js";
import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import Rating from './Rating.js';
import {PRESET_RATED} from 'decentralized/xanadu/LinkTypes.js';
import PresetsBreadcrumb from './PresetsBreadcrumb.js';
import PresetsExplorer from './PresetsExplorer.js';
import TagsInfo from './TagsInfo.js';
import CreatedBy from './CreatedBy.js';
import YoutubeInfo from "components/Youtube.js";
import {connect} from 'react-redux';
import '../../SynthBrowser.scss';
import Colors from 'components/Colors.js';

const colors = new Colors();

const SynthBrowser = ({track, subTrack, synth, setTagSelected, tagSelected, hasEdits, name, type=MULTI_SYNTH}) => { 
    let t = subTrack || track;
    let preset = t.preset;

    let color = colors.getColorForTrack(t);
    let thumbnailStyle = {
        backgroundColor: color
    };
    
    return (
        <div
          className="sampler-browser synth-browser">
          <div>
            <div style={thumbnailStyle} className="synth-thumbnail">
            </div>
            <PresetsBreadcrumb preset={preset} track={subTrack || track}/>
          </div>
          <div className="sample-info">
            <div className="name-info">
              <div className="sample-name">{name || t.presetName || t.getName()}</div>
              <CreatedBy hasEdits={hasEdits} content={preset}/>
              <div className="blank-patch">
                {!hasEdits && name === undefined ?
                 'Blank Patch' : ''}
              </div>
            </div>
            {preset.isCreated() ?
             <TagsInfo
               tags={preset.tags}
               tagSelected={tagSelected}
               setTagSelected={setTagSelected}
               content={preset}/>
             : ''}
            {!hasEdits && name ?
             <Rating
               color={color}
               content={preset.contentHash}
               type={PRESET_RATED}/> : ''}
          </div>
          <PresetsExplorer
            type={type}
            track={t}
            tagSelected={tagSelected}
            content={preset}
          />
          <ContextualHelp sequencerEngine={track.sequencerEngine}/>
        </div>
    );
}

const mapStateToProps = (state, {subTrack, track}) => {
    let t = subTrack || track;
    let preset = t.preset;
    return {
        hasEdits: preset.hasEdits === undefined ? true : preset.hasEdits,
        name: preset.name,
        tags: preset.tags,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SynthBrowser);
